<ng-template ngIf="fattura">
<div class="row">
	<ng-template
		[ngIf]="fattura.altraParte?.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
		<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Cognome e nome'" [valueInput]="fattura.altraParte?.parte.nominativo"></div>
	</ng-template>
	<ng-template
		[ngIf]="fattura.altraParte?.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
		<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Ragione sociale'" [valueInput]="fattura.altraParte?.parte.ragioneSociale"></div>
	</ng-template>
	<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo beneficiario'"
		[valueInput]="fattura.altraParte && fattura.altraParte.categoriaAltraParte ? fattura.altraParte.categoriaAltraParte.descrizione : ''"></div>
</div>
<div class="row">
	<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Numero fattura'" [valueInput]="fattura.numeroFattura"></div>

	<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'"
		[labelInput]="'Data fattura'" [valueInput]="fattura.dataEmissione"></div>

	<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Pagata a (giorni)'"	[valueInput]="fattura.numeroGiorniPagamento"></div>
</div>

<ng-template
	[ngIf]="fattura.attivitaFatture && fattura.attivitaFatture.length > 0">
<div class="row">
	<div class="col-sm-12">
		<table class="table-striped table aggiunta_classificazione">
			<caption>Attivit&agrave;</caption>
			<tbody>
				<tr>
					<th>Codice</th>
					<th>Fase</th>
					<th>Attivit&agrave;</th>
					<th>Importo</th>
				</tr>
				<ng-template ngFor
					let-attivitaFattura [ngForOf]="fattura.attivitaFatture">
				<tr>
					<td>{{attivitaFattura.codice}}</td>
					<td>{{attivitaFattura.tipoFase?.label}}</td>
					<td>{{attivitaFattura.attivita}}</td>
					<td class="alignright">{{attivitaFattura.importo | euro}} &euro;</td>
				</tr>
				</ng-template>
				<tr>
					<td></td>
					<td></td>
					<td class="alignright totale"><strong>Totale</strong></td>
					<td class="alignright totale"><strong>{{fattura.totaleImportoAttivita | euro}} &euro;</strong></td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
</ng-template>

<div class="container_conteggi">

	<div *ngFor="let altreSpese of [(fattura.totaleImportoAttivita | percentage:fattura.percentualeAltreSpese)]">
	<div *ngFor="let contribPrevidenziale of [( getSum(fattura.totaleImportoAttivita,altreSpese,fattura.speseImponibili) | percentage:fattura.percentualeContributoPrevidenziale)]">
	<div *ngFor="let totaleImponibile of [(getSum(fattura.totaleImportoAttivita,altreSpese,fattura.speseImponibili,contribPrevidenziale))]">
	<div *ngFor="let ivaImponibile of [(totaleImponibile | percentage:fattura.iva?.valore)]">
	<div *ngFor="let totale of [( getSum(totaleImponibile,ivaImponibile,fattura.speseEsenti) )]">
	<div *ngFor="let totalePerRitenutaAcconto of [( getSum(fattura.totaleImportoAttivita,altreSpese,fattura.speseImponibili) )]">
	<div *ngFor="let ritenutaAcconto of [(fattura.flagRitenutaAcconto ? ( getSum(fattura.totaleImportoAttivita,altreSpese,fattura.speseImponibili) | percentage:20) : 0 )]">
	<div *ngFor="let nettoAPagare of [(getDiff(totale,ritenutaAcconto))]">

	<div labelTextInput [labelInput]="'Importo totale attivit&agrave;'" [typeLabel]="'conteggioProspetto'" [valueInput]="fattura.totaleImportoAttivita"></div>

	<div *ngIf="fattura.percentualeAltreSpese" labelTextInput
		[typeLabel]="'conteggioProspetto'" [valueInput]="altreSpese"
		[labelInput]="'Altre spese e oneri ('+ fattura.percentualeAltreSpese +'%)'">
	</div>
	<div *ngIf="fattura.percentualeAltreSpese" class="col-sm-8 bloccodati">
		<p>
			<span class="longtext">{{ fattura.descrizioneAltreSpese }}</span>
		</p>
	</div>

	<div labelTextInput [labelInput]="'Spese non esenti'" [typeLabel]="'conteggioProspetto'" [valueInput]="fattura.speseImponibili"></div>

	<div *ngIf="fattura.percentualeContributoPrevidenziale" labelTextInput
		[typeLabel]="'conteggioProspetto'" [valueInput]="contribPrevidenziale"
		[labelInput]="'Contributo previdenziale ('+ fattura.percentualeContributoPrevidenziale +'%)'">
	</div>
	<div *ngIf="fattura.percentualeContributoPrevidenziale" class="col-sm-8 bloccodati">
		<p>
			<span class="longtext">{{ fattura.descrizioneContributoPrevidenziale }}</span>
		</p>
	</div>

	<div labelTextInput [labelInput]="'Totale imponibile'" [typeLabel]="'conteggioProspettoBold'" [valueInput]="totaleImponibile"></div>

	<div *ngIf="fattura.iva" labelTextInput [labelInput]="'IVA su imponibile ('+( fattura.iva ? fattura.iva.valore : 0)+'%)'"
		[typeLabel]="'conteggioProspetto'" [valueInput]="ivaImponibile"></div>

	<div labelTextInput [labelInput]="'Spese esenti ex art. 15 DPR 633/72'"	[typeLabel]="'conteggioProspetto'" [valueInput]="fattura.speseEsenti"></div>

	<div labelTextInput [labelInput]="'Totale'"	[typeLabel]="'conteggioProspettoBold'" [valueInput]="totale"></div>

	<div *ngIf="fattura.flagRitenutaAcconto" labelTextInput [typeLabel]="'conteggioProspetto'" [valueInput]="ritenutaAcconto"
		 [labelInput]="'A dedurre ritenuta di acconto 20% su '+totalePerRitenutaAcconto+' &euro;'"></div>

	<div labelTextInput [labelInput]="'Netto a pagare'"	[typeLabel]="'conteggioProspettoBold'" [valueInput]="nettoAPagare"></div>

	</div>
	</div>
	</div>
	</div>
	</div>
	</div>
	</div>
	</div>

</div>
	<div class="row">
		<div class="col-sm-12 bloccodati">
			<p>
				<label class="col-sm-12">Note</label>
				<span class="longtext">{{ fattura.note }}</span>
			</p>
		</div>
	</div>
</ng-template>
